import { render, staticRenderFns } from "./RadSkuDetail.vue?vue&type=template&id=2c91695e"
import script from "./RadSkuDetail.vue?vue&type=script&lang=js"
export * from "./RadSkuDetail.vue?vue&type=script&lang=js"
import style0 from "./RadSkuDetail.vue?vue&type=style&index=0&id=2c91695e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports